'use strict'

import React from 'react';

export default class SettingsForUsage extends React.Component {
  constructor(props) {
    super(props);
    this.state=this.loadSettings(props);
  }

  componentWillReceiveProps(props) {
    this.setState(this.loadSettings(props));
  }

  loadSettings(props) {
    return {
      edit: false,
      enabled: props.settings!==undefined && props.settings.enabled!==undefined ? props.settings.enabled : true
    };
  }


  changeSettings(event) {
    event.preventDefault();
    this.setState({edit:!this.state.edit});
  }

  enableBusinessCase(event) {
    this.setState({enabled:true});
  }

  disableBusinessCase(event) {
    this.setState({enabled:false});
  }

  cancelChange(event) {
    event.preventDefault();
    this.setState(this.loadSettings(this.props));
  }

  updateSettings(event) {
    event.preventDefault();
    this.setState({edit:false});
    if (this.props.onUpdate!==undefined) {
      this.props.onUpdate({
        area: this.props.area,
        use: this.state.enabled
      });
    }
  }


  render() {
    return (
      <div style={{display:"flex",paddingBottom:20, }}>
        <div>
          <img src={this.props.image}/>
        </div>
        {this.state.edit ? (
          <div style={{paddingLeft:30}}>
            Use {this.props.label}
            <div>
              <div>
                <input onChange={this.disableBusinessCase.bind(this)} type="radio" name="businessCase" value="no" defaultChecked={!this.state.enabled} id="no"/>
                <span> </span>
                <label htmlFor="no">No</label>
              </div>
              <div>
                <input onChange={this.enableBusinessCase.bind(this)} type="radio" name="businessCase" value="yes" defaultChecked={this.state.enabled} id="yes"/>
                <span> </span>
                <label htmlFor="yes">Yes</label>
              </div>
            </div>
            <div style={{paddingTop:15}}>
              <input type="button" onClick={this.cancelChange.bind(this)} className="cancel" value="Cancel"/>
              <input onClick={this.updateSettings.bind(this)} type="submit" className="save" value="Update"/>
            </div>
          </div>
        ) : (
          <div style={{paddingLeft:30}}>
            <div>{this.state.enabled ? "Use" : "Not use"} {this.props.label}.</div>
            <div style={{paddingTop:10}}>
              <i>{this.props.help}.</i>
            </div>
            <div style={{paddingTop:15}}>
              <a href="#" onClick={this.changeSettings.bind(this)}>Change</a>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/settings/SettingsForUsage.jsx